// extracted by mini-css-extract-plugin
export default {"load-more":"show-more-button_load-more__-KqLS","load-more-inner":"show-more-button_load-more-inner__BB1w2"};